import React, { useEffect } from "react";
import DynamicForm from "../stories/Forms/DynamicForm";
import { forgotPasswordFields,vhForgotPasswordFields } from "../stories/Forms/fields";
import { Container, Spinner } from "react-bootstrap";
import { forgotPasswordSchema,vhForgotPasswordSchema } from "../stories/Forms/validationSchema";
import { useAuth } from "../components/AuthContext/AuthContext";
import useApis from "../services/useAPI";
import EmailConfirmation from "./EmailConfirmation";
import { useNavigate, Link } from "react-router";
import { forgotPasswordUrl } from "../utils/constants";
import logo from "../assets/images/boots-myhealthchecked-logo.svg";
import LoggedOutLayout from "../stories/LoggedOutScreens/LoggedOutLayout";
import AccountCard from "../stories/Cards/AccountCard";
import { XCircleFill } from "react-bootstrap-icons";


let email;
// Global variable to control form visibility
let hideForm = false;

// Must match SSO_PASSWORD_RESET_NOT_ALLOWED_MESSAGE in
// backend/phlebotomists_portal/utilities/constants.py
const SSO_ACCOUNT_MESSAGE =
  "This account signs in via SSO. Please contact your administrator to manage your password.";

function ForgotPassword() {
  const auth = useAuth();
  const navigate = useNavigate();

  // Custom hook for API calls and state management
  const { callApi, serverError, message } =
    useApis(forgotPasswordUrl, "POST"); // Custom hook for API calls.

  const isSsoBlocked = serverError === SSO_ACCOUNT_MESSAGE && !!auth?.featureFlag;

  // Handle form submission and make API call
  const handleSubmit = async (data) => {
    email = data.email.toLowerCase();
    const payload = { email: data.email.toLowerCase() };
    callApi(payload);
  };

  // Effect to handle email setting, form hiding, and navigation
  useEffect(() => {
    auth.setEmail(email);
    if (isSsoBlocked) {
      // The URL only moves off /forgot-password once the request actually
      // reveals an SSO-managed account - not just from visiting this page.
      navigate("/account-access", { state: { ssoBlocked: true }, replace: true });
      return;
    }
    if (message) {
      auth.logout();
      navigate("/email-confirmation");
    }
    auth.setTitle("Forgot password");
  }, [auth.title, auth.email, message, isSsoBlocked, navigate]);

  // Surface forgot-password errors as a toast, mirroring LoginForm's
  // serverError handling.
  useEffect(() => {
    if (serverError && !isSsoBlocked) {
      auth?.showToast("Error", serverError, "../assets/mhc.png", {
        icon: <XCircleFill />,
      });
    }
  }, [serverError, isSsoBlocked]);

  if (auth.featureFlagLoading || isSsoBlocked)
      return (
        <div className="text-center">
          <Spinner
            animation="border"
            variant="info"
            className="my-custom-spinner"
          />
        </div>
      );


return (
  <div className="login-wrapper">
    {!auth.featureFlagLoading && auth?.featureFlag ? (
      <AccountCard
        title="Forgot your password?"
        subtitle="Enter your registered email address and we'll send you a link to reset your password."
        loginPage={true}
      >
        {!hideForm && (
          <div className="d-flex flex-column align-items-center w-100">
            <DynamicForm
              fields={vhForgotPasswordFields}
              onSubmit={handleSubmit}
              serverError={serverError}
              validationSchema={vhForgotPasswordSchema}
            />
            <div className="forget-password-link back-to-login-link text-center">
              <Link to="/">Back to login</Link>
            </div>
          </div>
        )}
      </AccountCard>
    ) : (
      <LoggedOutLayout
        className={
          auth.title === "Access dashboard"
            ? "login-bg login-page-container "
            : ""
        }
        logoSrc={logo}
        title={auth.title}
      >
        {!hideForm && (
          <Container>
            <p>
              Enter the email address associated with your account & we'll email
              you a password reset link
            </p>
            <div className="forgot-password-form">
              <DynamicForm
                fields={forgotPasswordFields}
                onSubmit={handleSubmit}
                serverError={serverError}
                validationSchema={forgotPasswordSchema}
              />
            </div>
          </Container>
        )}
      </LoggedOutLayout>
    )}
    {auth.email && message && <EmailConfirmation email={auth.email} />}
  </div>
);
}

export default ForgotPassword;
